





















































import Vue from "vue";
import ListItem from "@/components/molecules/ListItem.vue";
import SortableList from "@/components/molecules/SortableList.vue";
import ButtonSolid from "@/components/atoms/ButtonSolid.vue";
import { getWorldViewlKey } from "@/lib/s3";
import { callApi } from "@/lib/api";
import gql from "graphql-tag";

export default Vue.extend({
  components: { ListItem, SortableList, ButtonSolid },
  props: {
    novelId: String,
    worldViews: Array as any,
    selectedId: String,
    folder: Object,
    allFolders: Array as object,
    needsDoCustomClickFunction: {
      type: Boolean,
      default: false,
    },
    onClickItem: {
      type: Function,
      default: () => {
        return false;
      },
      required: false,
    }, // アイテムクリック時の処理を外部から指定したい場合に渡す
  },
  data() {
    return {
      isEditing: false,
      items: this.worldViews,
    };
  },
  watch: {
    items() {
      this.worldViews = this.items;
    },
    worldViews() {
      this.items = this.worldViews;
    },
  },
  methods: {
    async saveOrder() {
      const { novelId, items } = this;
      const order = items.map((item) => item.worldViewId);

      if (this.folder) {
        let folders = this.allFolders;
        folders.forEach((element) => {
          if (element.worldViewFolderId === this.folder.worldViewFolderId) {
            element.worldViewKeys = order;
          }
        });
        const query = `
            mutation UpdateWorldViewFolder ($input: UpdateWorldViewFolderInput!){
              updateWorldViewFolder (input: $input) {
                novelId
                items {
                 worldViewFolderId
                 name
                 worldViewKeys
               }
              }
            }
        `;
        await callApi(query, {
          input: {
            novelId,
            items: folders,
          },
        });

        try {
          this.worldViews.sort((x, y) => {
            return this.folder.worldViewKeys.indexOf(x.worldViewId) - this.folder.worldViewKeys.indexOf(y.worldViewId);
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        await callApi(
          gql`
            mutation UpdateDisplayOrder($input: UpdateDisplayOrderInput!) {
              updateDisplayOrder(input: $input) {
                order
              }
            }
          `,
          {
            input: {
              novelId,
              kind: "worldView",
              order,
            },
          }
        );
      }

      this.isEditing = false;
    },
    getWorldViewlKey(worldView) {
      return getWorldViewlKey(this.novelId, worldView);
    },
    backToFolderList() {
      this.$emit("backToFolderList");
    },
    setFolder(el) {
      this.$emit("clickSetFolder", {
        worldView: el.item,
        worldViewFolder: this.folder,
      });
    },
  },
});
